import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that requires control to have a minimum value only if it satisfies the passed condition.
 */
export const MinIfValidator = (min: number, condition: boolean): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    const value = Number(activeControl.value);
    return condition && value < min ? { min: { min, actual: value } } : null;
  };
};

/**
 * Validator that requires control to have a maximum value only if it satisfies the passed condition.
 */
export const MaxIfValidator = (max: number, condition: boolean): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    const value = Number(activeControl.value);
    return condition && value > max ? { max: { max, actual: value } } : null;
  };
};
